import {injectable, inject} from "inversify";
import {AxiosResponse} from "axios";
import type {IApiResponse, IHttpClientService} from "data/services/http";
import {Bindings} from "data/constants/bindings";

export interface ICountryProvider {
	check: () => Promise<AxiosResponse<IApiResponse<{ifAllowed: boolean}>>>;
}

@injectable()
export class CountryProvider implements ICountryProvider {
	constructor(@inject(Bindings.ApiHTTPClient) private _http: IHttpClientService) {}

	check = (): Promise<AxiosResponse<IApiResponse<{ifAllowed: boolean}>>> =>
		this._http.get<
			IApiResponse<{
				ifAllowed: boolean;
			}>
		>(`geo`);
}
